import { Survey, SurveyLookup, SurveySubmissionData } from './survey';
import { EngagementStatusBlock } from './engagementStatusBlock';
import { SubmissionStatus } from 'constants/engagementStatus';

// What the selectors need of an engagement: enough to label an option and reach its survey.
export interface EngagementLookup {
    id: number;
    name: string;
    surveys: SurveyLookup[];
}

export interface Engagement {
    id: number;
    name: string;
    description: string;
    rich_description: string;
    status_id: number;
    start_date: string;
    end_date: string;
    published_date: string | null;
    user_id: string;
    created_date: string;
    updated_date: string;
    scheduled_date: string;
    content: string;
    rich_content: string;
    banner_url: string;
    banner_filename: string;
    surveys: Survey[];
    engagement_status: Status;
    submission_status: SubmissionStatus;
    submissions_meta_data: SurveySubmissionData;
    status_block: EngagementStatusBlock[];
    visibility: number;
    engagement_visibility: Visibility;
}

// What GET /engagements/ actually returns. An Omit of Engagement so a field added there
// has to be considered here.
export type EngagementListItem = Omit<
    Engagement,
    'content' | 'rich_content' | 'rich_description' | 'status_block' | 'surveys'
> & {
    surveys: SurveyLookup[];
};

export interface Status {
    id: number;
    status_name: string;
}

export interface Visibility {
    id: number;
    visibility_name: string;
}

export interface EngagementMetadata {
    engagement_id: number;
    project_id: string;
    project_metadata: ProjectMetadata;
}

export interface EngagementSettings {
    engagement_id: number;
    send_report: boolean;
}

export interface ProjectMetadata {
    project_name: string;
    type: string;
    client_name: string;
    application_number: string;
}

export const createDefaultEngagement = (): Engagement => {
    return {
        id: 0,
        name: '',
        description: '',
        rich_description: '',
        status_id: 0,
        start_date: '',
        end_date: '',
        published_date: '',
        scheduled_date: '',
        user_id: '',
        created_date: '',
        updated_date: '',
        banner_url: '',
        banner_filename: '',
        content: '',
        rich_content: '',
        engagement_status: { id: 0, status_name: '' },
        surveys: [],
        submission_status: SubmissionStatus.Upcoming,
        submissions_meta_data: {
            total: 0,
            pending: 0,
            needs_further_review: 0,
            rejected: 0,
            approved: 0,
        },
        status_block: [],
        visibility: 0,
        engagement_visibility: { id: 0, visibility_name: '' },
    };
};

export const createDefaultEngagementMetadata = (): EngagementMetadata => {
    return {
        engagement_id: 0,
        project_id: '',
        project_metadata: {
            client_name: '',
            type: '',
            project_name: '',
            application_number: '',
        },
    };
};

export const createDefaultEngagementSettings = (): EngagementSettings => {
    return {
        engagement_id: 0,
        send_report: true,
    };
};
